import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loginModal: false,
  sigupModal: false,
  forgotPasswordModal: false,
  confirmPassword: true,
  twoFactorChallengeModal: true,
};

const modalSlice = createSlice({
  name: "modalSlice",
  initialState,
  reducers: {
    toggleLogin: (state, action) => {
      state.loginModal = !state.loginModal;
    },
    toggleSignUp: (state, action) => {
      state.sigupModal = !state.sigupModal;
    },
    toggleForgotPassword: (state, action) => {
      state.forgotPasswordModal = !state.forgotPasswordModal;
    },
    toogleConfirmPassword: (state, action) => {
      state.confirmPassword = !state.confirmPassword;
    },
    toogleTwoFactorChallengeModal: (state, action) => {
      state.twoFactorChallengeModal = !state.twoFactorChallengeModal;
    },
  },
});

export const {
  toggleLogin,
  toggleSignUp,
  toggleForgotPassword,
  toogleConfirmPassword,
  toogleTwoFactorChallengeModal,
} = modalSlice.actions;
export default modalSlice.reducer;
